import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const Api = require('./Config');

const NoteModal = ({ show, PMHID, t_code, onClose }) => {
  const [newNote, setNewNote] = useState('');

  useEffect(() => {
    if (PMHID) {
      Api.getNote(PMHID).then(({ note }) => {
        setNewNote(note);
      });
    }
  }, [PMHID]);

  const handleSaveNote = () => {
    Api.saveNote(PMHID, newNote);
    onClose({
      PMHID: PMHID,
      note: newNote,
    });
  };

  return (
    <Modal show={show} onHide={onClose} restoreFocus={false}>
      <Modal.Header>
        <Modal.Title>Note: {t_code}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <textarea
          className="form-control"
          style={{ minHeight: 300 }}
          value={newNote || ''}
          onChange={(e) => setNewNote(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={handleSaveNote} className="btn btn-success">
          Save
        </button>
        <button type="button" onClick={onClose} className="btn btn-info">
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoteModal;
